import React, { useEffect } from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { connect } from "react-redux";
import { Popover, Div, AddPhotoIcon } from "components/Base";
import Gravatar from "components/Global/Gravatar";

import Loading from "ui-kit/Loading";
import Footer from "./Footer";

import Tabs from "./Tabs";
import { getters as TabGetters } from "ui-kit/Tabs";
import {
  TAB_INSTANCE_IDS,
  TAB_IDS,
  FORM_INSTANCE_ID,
  FIELD_IDS,
  FIELD_IDS_ACTIVE_ACCOUNT
} from "../constants";

import { actions, getters } from "../model";
import styles from "./styles.scss";

import { noop } from "utils/General";

import { AttendeePhoto, WithFormInstanceProvider } from "ui-kit/Form/View";

import ProfileInfo from "./ProfileInfo";
import EventInfo from "./EventInfo";
import {
  getProfilePhotoValue,
  getProfileName,
  getProfileEmail,
  isViewingAsAccount
} from "../selectors";

const decorate = R.compose(
  WithFormInstanceProvider(R.always(FORM_INSTANCE_ID)),
  connect(
    state => ({
      name: getProfileName(state),
      email: getProfileEmail(state),
      photoUrl: getProfilePhotoValue(state),
      selectedTab: TabGetters.selectedTab(state, {
        instanceId: TAB_INSTANCE_IDS
      }),
      loading: getters.loading(state),
      isViewingAsAccount: isViewingAsAccount(state),
      lockedFieldIds: getters.lockedFieldIds(state),
      visibleFieldIds: getters.visibleFieldIds(state)
    }),
    {
      init: actions.init
    }
  ),
  CSSModules(styles)
);

const Overlay = () => (
  <Div
    className="showOnHover"
    bg="primary5"
    style={{
      borderRadius: 3,
      position: "absolute",
      opacity: 0.4,
      right: 0,
      left: 0,
      bottom: 0,
      top: 0
    }}
  />
);

const Icon = () => (
  <AddPhotoIcon
    size={34}
    color="neutral0"
    className="showOnHover"
    style={{
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)"
    }}
  />
);

const Body = ({
  init = noop,
  name = "",
  email = "",
  photoUrl = null,
  selectedTab = TAB_IDS.PROFILE_INFO,
  loading = false,
  isViewingAsAccount,
  lockedFieldIds,
  visibleFieldIds
}) => {
  useEffect(() => {
    init();
  }, []);

  const Content = R.prop(selectedTab)({
    [TAB_IDS.PROFILE_INFO]: ProfileInfo,
    [TAB_IDS.EVENT_INFO]: EventInfo
  });

  const photoFieldId = isViewingAsAccount
    ? FIELD_IDS_ACTIVE_ACCOUNT.LOGO_URL
    : FIELD_IDS.AVATAR_URL;
  const isPhotoFieldVisible = visibleFieldIds.includes(photoFieldId);
  const isPhotoFieldLocked = lockedFieldIds.includes(photoFieldId);

  return (
    <>
      <div className={styles.profileContainer}>
        <div className={styles.profileHeader}>
          {isPhotoFieldVisible ? (
            <Popover
              Label={({ onClick }) => (
                <Div
                  onClick={isPhotoFieldLocked ? undefined : onClick}
                  className={isPhotoFieldLocked ? undefined : "hoverContainer"}
                  style={{
                    position: "relative",
                    height: "80px"
                  }}
                >
                  <Gravatar size={80} url={photoUrl} />
                  {isPhotoFieldLocked ? null : <Overlay />}
                  {isPhotoFieldLocked ? null : <Icon />}
                </Div>
              )}
            >
              {() => (
                //{ closePopover }
                <AttendeePhoto
                  fieldId={photoFieldId}
                  iniValue={{
                    url: photoUrl
                  }}
                />
              )}
            </Popover>
          ) : null}
          <div className={styles.profileHeaderTextContainer}>
            <div className={styles.profileNameContainer}>
              <div className={styles.profileName}>{name}</div>
            </div>
            {!isViewingAsAccount && email && email.length ? (
              <div className={styles.profileEmail}>{email}</div>
            ) : null}
          </div>
        </div>
        <Tabs />
        <Div width={1} display="column.flex-start.flex-start">
          {loading ? <Loading /> : Content ? <Content /> : null}
        </Div>
        <Footer />
      </div>
    </>
  );
};

export default decorate(Body);
